import { auth } from "../auth/auth";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import Logo from "./Logo";

export default function Header({ children, centerAlign = "center" }) {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header style={styles.header}>
      {/* LEFT */}
      <div style={styles.left}>
        <Logo onClick={() => navigate("/")} />
      </div>

      {/* CENTER (optional slot) */}
      {children && <div style={{ ...styles.center, ...styles.centerAlignmentStyles[centerAlign] }}>{children}</div>}

      {/* RIGHT */}
      <div style={styles.right}>
        {user && (
          <div style={styles.profileWrapper} ref={dropdownRef}>
            <img
              src={user.photoURL}
              referrerPolicy="no-referrer"
              alt="User"
              style={styles.avatar}
              onClick={() => setOpen((v) => !v)}
            />

            {open && (
              <div style={styles.dropdown}>
                <button
                  style={styles.item}
                  onClick={async () => {
                    await signOut(auth);
                    setOpen(false);
                    navigate("/");
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}

const styles = {
  centerAlignmentStyles: {
    left: { justifyContent: "flex-start" },
    center: { justifyContent: "center" },
    right: { justifyContent: "flex-end" },
  },
  header: {
    height: 55,  //in other places we use 56 to substract from 100vh to ensure no scroll bar
    padding: "0 24px",
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    alignItems: "center",
    borderBottom: "1px solid #eee",
    gap: 16,
  },
  left: {
    display: "flex",
    alignItems: "center",
  },
  center: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    justifyContent: "center",
  },
  right: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  profileWrapper: {
    position: "relative",
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    cursor: "pointer",
  },
  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    minWidth: 140,
    zIndex: 1000,
  },
  item: {
    width: "100%",
    padding: "10px 12px",
    background: "none",
    border: "none",
    textAlign: "left",
    cursor: "pointer",
  },
};
